import React from 'react';
import Navbar from '../components/NavBar';
import Sidebar from '../components/Sidebar';
import { useNetwork } from '../components/NetworkContext';
// import '../App.css';

const Home = () => {
    const { network, walletAddress, setNetwork, setWalletAddress } = useNetwork();
    return (
        <div>

            <div className="container-scroller">
                <Sidebar />
                <div className="container-fluid page-body-wrapper">
                    <Navbar />
                    <div className="main-panel">
                        <div className="content-wrapper">

                            <h1>Welcome to the CatBonds Application</h1>
                            <p>Your connected wallet address is: {walletAddress}</p>


                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Home;